import {
  isFirebaseError,
  isOrganizationInvitation,
  isWorkspaceInvitation,
} from '@/utils/typeGuards';
import { sanitizeUserFacingString } from '@/utils/sanitizeCallableErrorMessage';

export const LOADER_FIREBASE_ERROR_FALLBACK =
  'This invitation could not be loaded. Check your link or ask your admin for a new invitation.';

export type InvitationLoaderView =
  | { kind: 'workspace'; workspaceName: string; organizationName: string }
  | { kind: 'organization'; organizationName: string }
  | { kind: 'error'; message: string; isWrongUser: boolean }
  | { kind: 'unknown' };

export const WRONG_USER_INVITATION_MESSAGE = 'User email does not match invitation';

export function getInvitationLoaderView(data: unknown): InvitationLoaderView {
  if (isWorkspaceInvitation(data)) {
    return {
      kind: 'workspace',
      workspaceName: data.workspaceName ?? '',
      organizationName: data.organizationName ?? '',
    };
  }
  if (isOrganizationInvitation(data)) {
    return { kind: 'organization', organizationName: data.organizationName ?? '' };
  }
  if (isFirebaseError(data)) {
    return {
      kind: 'error',
      message: sanitizeUserFacingString(data.message, LOADER_FIREBASE_ERROR_FALLBACK),
      isWrongUser: data.message === WRONG_USER_INVITATION_MESSAGE,
    };
  }
  return { kind: 'unknown' };
}

export function shouldAutoAcceptInvitation(data: unknown): boolean {
  if (isFirebaseError(data)) return false;
  return isWorkspaceInvitation(data) || isOrganizationInvitation(data);
}
